import FusePageSimple from '@fuse/core/FusePageSimple';
import { Typography, makeStyles } from '@material-ui/core';
import StandardButton from 'app/components/StandardButton';
import usePageTitle from 'app/hooks/usePageTitle';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import bckgrndImg from './sky-background.png';

const useStyles = makeStyles(theme => ({
	txt: {
		color: 'white',
		'& img': {
			display: 'inline-block',
			margin: '15px 25px',
			height: 35
		},
		'&.MuiTypography-h2': {
			'&:last-of-type': {
				marginLeft: 50
			}
		},
		'&.MuiTypography-h6': {
			marginBottom: 10
		}
	},
	arrow: {
		display: 'block',
		textAlign: 'center',
		marginTop: -150
	},
	section: {
		'&:nth-of-type(odd)': {
			'& img': {
				verticalAlign: 'middle',
				width: '40%',
				margin: '0 5%',
				display: 'inline-block'
			},
			'& span': {
				verticalAlign: 'middle',
				width: '45%',
				margin: '0 5%',
				marginLeft: 0,
				display: 'inline-block'
			}
		},
		'&:nth-of-type(even)': {
			'& img': {
				verticalAlign: 'middle',
				width: '40%',
				margin: '0 5%',
				display: 'inline-block'
			},
			'& span': {
				verticalAlign: 'middle',
				width: '45%',
				margin: '0 5%',
				marginRight: 0,
				display: 'inline-block'
			}
		},
		display: 'block'
	},
	learn: {
		width: '42.5%',
		background: 'rgba(0, 0, 0, 0.1)',
		display: 'inline-block',
		margin: '0 5%',
		padding: 25,
		paddingTop: 0,
		'& img': {
			margin: '25px auto'
		},
		'& button': {
			margin: '25px auto'
		},
		'&:first-of-type': {
			marginRight: '2.5%'
		},
		'&:last-of-type': {
			marginLeft: '2.5%'
		}
	},
	background: {
		backgroundImage: `url('${bckgrndImg}')`,
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		width: '100%',
		height: '100vh',
		position: 'fixed',
		zIndex: -1,
		left: 0
	},
	root: {
		marginBottom: -35
	}
}));

function WelcomePage() {
	useEffect(() => {
		//
		return () => {
			//
		};
	}, []);

	const { t } = useTranslation();
	const history = useHistory();
	usePageTitle('Welcome');
	const classes = useStyles();

	return (
		<FusePageSimple
			classes={{
				header: 'min-h-128 h-auto mb-0',
				root: classes.root
			}}
			content={
				<div>
					<div className={classes.background} />
					<Typography
						variant="h2"
						className={classes.txt}
						style={{ marginTop: 25, marginBottom: -15, fontWeight: 500 }}
					>
						{t('stratus:landing:heading high left')}
						<span style={{ fontWeight: 700 }}>{t('stratus:landing:heading high right')}</span>
					</Typography>
					<Typography variant="h2" className={classes.txt} style={{ marginBottom: 20, fontWeight: 500 }}>
						{t('stratus:landing:heading low left')}
						<span style={{ fontWeight: 800, fontSize: '7rem' }}>
							{t('stratus:landing:heading low right')}
						</span>
					</Typography>
					<div style={{ marginLeft: 50, width: 1075 }}>
						<Typography variant="h6" className={classes.txt}>
							{t('stratus:landing:intro title')}
							<Link to="/about-dispatcher-stratus">
								<img
									src={`${process.env.PUBLIC_URL}/assets/images/landing/logo_stratus-2.svg`}
									alt=""
								/>
							</Link>
							<Link to="/about-dispatcher-scantrip-cloud">
								<img
									src={`${process.env.PUBLIC_URL}/assets/images/landing/logo_scantrip-cloud-outlined.svg`}
									alt=""
								/>
							</Link>
						</Typography>
						<Typography className={classes.txt}>{t('stratus:landing:intro text')}</Typography>
					</div>
					<section className={classes.section}>
						<img src={`${process.env.PUBLIC_URL}/assets/images/landing/iStock-1284636483.png`} alt="" />
						<span>
							<Typography variant="h6" className={classes.txt}>
								{t('stratus:landing:digital title')}
							</Typography>
							<Typography className={classes.txt}>{t('stratus:landing:digital text')}</Typography>
						</span>
					</section>
					<img
						className={classes.arrow}
						style={{ marginLeft: '40%' }}
						src={`${process.env.PUBLIC_URL}/assets/images/landing/arrow1.png`}
						alt=""
					/>
					<section className={classes.section}>
						<span>
							<Typography variant="h6" className={classes.txt}>
								{t('stratus:landing:people title')}
							</Typography>
							<Typography className={classes.txt}>{t('stratus:landing:people text')}</Typography>
						</span>
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/landing/illustrated-path-people.png`}
							alt=""
						/>
					</section>
					<img
						className={classes.arrow}
						style={{ marginLeft: '25%' }}
						src={`${process.env.PUBLIC_URL}/assets/images/landing/arrow2.png`}
						alt=""
					/>
					<section className={classes.section}>
						<img src={`${process.env.PUBLIC_URL}/assets/images/landing/illustrated-path-auto.png`} alt="" />
						<span>
							<Typography variant="h6" className={classes.txt}>
								{t('stratus:landing:automate title')}
							</Typography>
							<Typography className={classes.txt}>{t('stratus:landing:automate text')}</Typography>
						</span>
					</section>
					<img
						className={classes.arrow}
						style={{ marginLeft: '40%' }}
						src={`${process.env.PUBLIC_URL}/assets/images/landing/arrow3.png`}
						alt=""
					/>
					<section className={classes.section}>
						<span>
							<Typography variant="h6" className={classes.txt}>
								{t('stratus:landing:jobs title')}
							</Typography>
							<Typography className={classes.txt}>{t('stratus:landing:jobs text')}</Typography>
							<div style={{ margin: '25px auto', width: 315 }}>
								<StandardButton
									btnText={t('welcome:button:CTA')}
									style={{ width: 315 }}
									onClick={() => history.push('/features')}
								/>
							</div>
						</span>
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/landing/illustration-path-complete.png`}
							alt=""
						/>
					</section>
					<hr style={{ marginTop: 20, background: 'white', margin: 'auto', width: '90%' }} />
					<Typography variant="h6" className={classes.txt} style={{ textAlign: 'center', margin: 20 }}>
						{t('stratus:landing:learn')}
					</Typography>
					<section style={{ display: 'flex' }}>
						<span className={classes.learn}>
							<img
								src={`${process.env.PUBLIC_URL}/assets/images/landing/logo_stratus-2.svg`}
								alt=""
								style={{ width: 225 }}
							/>
							<Typography className={classes.txt}>{t('stratus:landing:learn stratus')}</Typography>
							<div style={{ margin: '25px auto', textAlign: 'center' }}>
								<StandardButton
									btnText={t('Learn More')}
									onClick={() => history.push('/about-dispatcher-stratus')}
								/>
							</div>
						</span>
						<span className={classes.learn}>
							<img
								src={`${process.env.PUBLIC_URL}/assets/images/landing/logo_scantrip-cloud-outlined.svg`}
								alt=""
								style={{ width: 329 }}
							/>
							<Typography className={classes.txt}>{t('stratus:landing:learn stc')}</Typography>
							<div style={{ margin: '25px auto', textAlign: 'center' }}>
								<StandardButton
									btnText={t('Learn More')}
									onClick={() => history.push('/about-dispatcher-scantrip-cloud')}
								/>
							</div>
						</span>
					</section>
				</div>
			}
		/>
	);
}

export default WelcomePage;
